import ACTION_TYPES from "../ActionTypes";

const { MYPAGE } = ACTION_TYPES;
// LIST EXPERIENCE REDUCER

const experienceValue = {
  experienceData: [],
  error: null,
  loading: false,
};

export const ReducerListExperience = (state = experienceValue, action) => {
  switch (action.type) {
    case MYPAGE.GET_EXPERIENCE_START:
      return { ...state, loading: true };
    case MYPAGE.GET_EXPERIENCE_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.GET_EXPERIENCE_SUCCESS:
      return { ...state, experienceData: action.payload, loading: false };
    default:
      return state;
  }
};
// LIST INVITATION

const initationValue = {
  invitationData: {},
  error: null,
  loading: false,
};

export const ReducerListInvitation = (state = initationValue, action) => {
  switch (action.type) {
    case MYPAGE.GET_INVITATION_START:
      return { ...state, loading: true };
    case MYPAGE.GET_INVITATION_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.GET_INVITATION_SUCCESS:
      return { ...state, invitationData: action.payload, loading: false };
    default:
      return state;
  }
};

const invitationAttend = {
  dataAttend: {},
  error: null,
  loading: false,
};

export const ReducerListInvitationAttend = (state = invitationAttend, action) => {
  switch (action.type) {
    case MYPAGE.GET_INVITATION_ATTEND_START:
      return { ...state, loading: true };
    case MYPAGE.GET_INVITATION_ATTEND_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.GET_INVITATION_ATTEND_SUCCESS:
      return { ...state, dataAttend: action.payload, loading: false };
    default:
      return state;
  }
};

// ATTEND INVITATION DATA
const attendInvitaton = {
  attendInvtdata: [],
  error: null,
  loading: false,
};

export const ReducerAttendInvitation = (state = attendInvitaton, action) => {
  switch (action.type) {
    case MYPAGE.GET_EXPERIENCE_START:
      return { ...state, loading: true };
    case MYPAGE.GET_EXPERIENCE_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.GET_EXPERIENCE_SUCCESS:
      return { ...state, attendInvtdata: action.payload, loading: false };
    default:
      return state;
  }
};

// FORM REVIEW
const reviewForm = {
  reviewform: [],
  error: null,
  loading: false,
};

export const ReducerReviewForm = (state = reviewForm, action) => {
  switch (action.type) {
    case MYPAGE.POST_REVIEW_FORM_START:
      return { ...state, loading: true };
    case MYPAGE.POST_REVIEW_FORM_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.POST_REVIEW_FORM_SUCCESS:
      return { ...state, reviewform: action.payload, loading: false };
    default:
      return state;
  }
};

// LIST REVIEW
const review = {
  review: [],
  error: null,
  loading: false,
};

export const ReducerReview = (state = review, action) => {
  switch (action.type) {
    case MYPAGE.GET_REVIEW_START:
      return { ...state, loading: true };
    case MYPAGE.GET_REVIEW_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.GET_REVIEW_SUCCESS:
      return { ...state, review: action.payload, loading: false };
    default:
      return state;
  }
};

// IMAGE TRACKER
const imageTrackerValue = {
  dataImage: [],
  error: null,
  loading: false,
};

export const ReducerImageTracker = (state = imageTrackerValue, action) => {
  switch (action.type) {
    case MYPAGE.POST_IMAGE_TRACKER_START:
      return { ...state, loading: true };
    case MYPAGE.POST_IMAGE_TRACKER_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.POST_IMAGE_TRACKER_SUCCESS:
      return { ...state, dataImage: action.payload, loading: false };
    default:
      return state;
  }
};

// Cancel Campaign
const cancelCampaign = {
  dataCancelCampaign: [],
  error: null,
  loading: false,
};

export const ReducerCancelCampaign = (state = cancelCampaign, action) => {
  switch (action.type) {
    case MYPAGE.POST_IMAGE_TRACKER_START:
      return { ...state, loading: true };
    case MYPAGE.POST_IMAGE_TRACKER_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.POST_IMAGE_TRACKER_SUCCESS:
      return { ...state, dataCancelCampaign: action.payload, loading: false };
    default:
      return state;
  }
};

// Update Profile
const updateProfile = {
  dataupdateProfile: [],
  error: null,
  loading: false,
};

export const ReducerUpdateProfile = (state = updateProfile, action) => {
  switch (action.type) {
    case MYPAGE.PUT_PROFILE_START:
      return { ...state, loading: true };
    case MYPAGE.PUT_PROFILE_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.PUT_PROFILE_SUCCESS:
      return { ...state, dataupdateProfile: action.payload, loading: false };
    default:
      return state;
  }
};

// Update Password
const updatePassword = {
  dataupdatePassword: [],
  error: null,
  loading: false,
};

export const ReducerUpdatePassword = (state = updatePassword, action) => {
  switch (action.type) {
    case MYPAGE.PUT_PASSWORD_START:
      return { ...state, loading: true };
    case MYPAGE.PUT_PASSWORD_FAILED:
      return { ...state, error: action.payload, loading: false };
    case MYPAGE.PUT_PASSWORD_SUCCESS:
      return { ...state, dataupdatePassword: action.payload, loading: false };
    default:
      return state;
  }
};